import * as _ from 'lodash';
import * as moment from 'moment';
import { InputGroup } from 'react-bootstrap';

interface IProps {
    dialysisStartDate: string,
}

const DialysisDurationLabel = (props: IProps) => {
    const yearMonthDayToNow = (from: string) => {
        let currentDate = moment();
        let fromStartDate = moment(from, 'YYYY-MM-DD');

        let yearDiff = -1;
        let monthDiff = -1;
        let dayDiff = -1;

        if (currentDate > fromStartDate) {
            yearDiff = currentDate.diff(fromStartDate, 'year');
            fromStartDate.add(yearDiff, 'years');

            monthDiff = currentDate.diff(fromStartDate, 'months');
            fromStartDate.add(monthDiff, 'months');

            dayDiff = currentDate.diff(fromStartDate, 'days');
        }

        return { yearDiff, monthDiff, dayDiff };
    }

    let backgroundColor = 'white';
    let color = '#555';
    let dialysisLabel = '';

    let dialysisStartDate = moment(props.dialysisStartDate, 'YYYY-MM-DD', true);
    let isValid = dialysisStartDate.isValid();

    if (isValid == false) {
        dialysisLabel = '[Invalid date specified]';
    } else {
        if (dialysisStartDate.isSameOrBefore(moment(), 'day')) {
            let { yearDiff, monthDiff, dayDiff } = yearMonthDayToNow(props.dialysisStartDate);

            let yrString = yearDiff == 1 ? ' Year, ' : ' Years, ';
            let mString = monthDiff == 1 ? ' Month, ' : ' Months, ';
            let dString = dayDiff == 1 ? ' Day' : ' Days';

            dialysisLabel = yearDiff + yrString + monthDiff + mString + dayDiff + dString;

            if (yearDiff >= 3) {
                backgroundColor = 'lightgoldenrodyellow';
            }
        } else {
            dialysisLabel = '[Invalid date specified]';
        }
    }

    return (
        <InputGroup.Addon style={{ backgroundColor, color }}>{dialysisLabel}</InputGroup.Addon>
    );
}


export default DialysisDurationLabel;
